import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import arrowRightIcon from '../../../../../assets/svgs/arrow_right-icon.svg';
import closeIcon from '../../../../../assets/svgs/close-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { isDadosLoginTokenValid } from '../../../../../utils/dados-login.util';
import { isJson } from '../../../../../utils/isJson.util';
import { useNotificationContext } from '../context/NotificationContext';
import { NotificationToastProps } from '../types/notificationTypes';

const apiNotificacoes = apiSensedia;

export const NotificationToast = ({
  open,
  action,
  children
}: NotificationToastProps) => {
  const { openNotifications, setUnreadNotificationsTotal } =
    useNotificationContext();
  const location = useLocation();

  const [lastNotificationRead, setLastNotificationRead] = useState([]);

  const [notShowNotificationToast, setNotShowNotificationToast] =
    useState(false);
  const [isNotificationsPopoverOpen, setIsNotificationsOpen] = useState(open);

  const [isLoading, setIsLoading] = useState(false);

  const getLastNotificationRead = async () => {
    const parsedUser = JSON.parse(user);
    const userDataToken = localStorage.getItem('user-data-token');
    const isUserLoggedIn = parsedUser?.user;

    const isUserDataTokenValid = isDadosLoginTokenValid();

    const pathname = location.pathname;

    if (
      pathname.includes('/corretor') &&
      isUserLoggedIn &&
      tokenPortal &&
      isUserDataTokenValid
    ) {
      setIsLoading(true);
      try {
        const response = await apiNotificacoes.get(
          `notificacoes/notificacoes-tela?lida=false&_limit=1&_offset=0`,
          {
            headers: {
              'user-data-info': userDataToken
            }
          }
        );

        setLastNotificationRead(response.data._embedded._result);
        setUnreadNotificationsTotal(response.data._embedded._total);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }
  };

  const style = {
    color: '#FF5000',
    fontWeight: '700'
  };

  const notificationObj = {
    'novo lead': 'Você recebeu um novo lead.',
    'novos leads': 'Você recebeu novos leads.',
    'nova venda': 'Uma venda acaba de ser concluída.',
    'novo agendamento': 'Você tem um agendamento',
    'novos agendamentos': 'Você tem novos agendamentos'
  };

  const pathName = window.location.pathname;

  const user = localStorage.getItem('pdn:user');
  const tokenPortal = localStorage.getItem('tokenPortal');

  useEffect(() => {
    if (isNotificationsPopoverOpen === false) {
      localStorage.setItem(
        'lastClosedNotification',
        JSON.stringify(lastNotificationRead[0])
      );
    }
  }, [isNotificationsPopoverOpen]);

  useEffect(() => {
    getLastNotificationRead();
  }, [location.pathname, tokenPortal]);

  useEffect(() => {
    const lastClosedNotificationJSON = localStorage.getItem(
      'lastClosedNotification'
    );

    const lastClosedNotification = isJson(lastClosedNotificationJSON)
      ? JSON.parse(lastClosedNotificationJSON)
      : undefined;

    const showNewNotification =
      !lastClosedNotification?.created_at ||
      new Date(lastNotificationRead[0]?.created_at) >
        new Date(lastClosedNotification?.created_at);

    setNotShowNotificationToast(
      pathName.length <= 1 ||
        pathName.includes('/notificacoes') ||
        pathName.startsWith('/login') ||
        pathName.startsWith('/confirmacao-email') ||
        openNotifications ||
        !isNotificationsPopoverOpen ||
        !showNewNotification
    );
  }, [
    location,
    openNotifications,
    lastNotificationRead,
    isNotificationsPopoverOpen
  ]);

  return (
    <div>
      <div
        style={{
          display:
            notShowNotificationToast || lastNotificationRead.length < 1
              ? 'none'
              : 'block',
          borderLeft: `9px solid ${style.color}`
        }}
        className="tw-bg-white tw-w-[91%] md:tw-w-[27rem] tw-pl-10 tw-pr-7 tw-py-5 tw-rounded-2xl tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-fixed tw-bottom-3 md:tw-bottom-14 -tw-left-1/4 md:tw-right-12 tw-z-20"
      >
        {isLoading ? (
          <div className="tw-py-5 tw-flex tw-items-center tw-justify-center">
            <div
              style={{ borderTopColor: 'transparent' }}
              className="tw-w-12 tw-h-12 tw-border-4 tw-border-[#001E64] tw-border-solid tw-rounded-full tw-animate-spin"
            ></div>
          </div>
        ) : (
          <>
            <div className="tw-flex tw-justify-between tw-items-center">
              <ul className="tw-list-disc">
                <li style={style} className="tw-text-[1.5rem]">
                  {lastNotificationRead.map((item, index) => {
                    return (
                      <span
                        key={index}
                        className="tw-text-[#333] tw-text-[1rem] tw-font-normal"
                      >
                        {notificationObj[String(item?.assunto).toLowerCase()]}
                      </span>
                    );
                  })}
                </li>
              </ul>
              <button
                onClick={() => {
                  setIsNotificationsOpen(false);
                }}
              >
                <CustomIcon src={closeIcon} width={12} height={12} />
              </button>
            </div>

            <button
              style={style}
              className="tw-flex tw-gap-2 tw-underline tw-mt-5"
              onClick={() => action()}
            >
              Ver mais detalhes
              <CustomIcon
                src={arrowRightIcon}
                width={20}
                height={20}
                color={style.color}
              />
            </button>
          </>
        )}
      </div>
      {children}
    </div>
  );
};
